import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpeechService {

  recognition: any;
  public resultado$ = new Subject<string>();

  constructor() {
    try{
      const { webkitSpeechRecognition }: any = window;
      this.recognition = new webkitSpeechRecognition();
      this.recognition.continuous = false; // Se detiene al terminar la frase
      this.recognition.interimResults = false;
      this.recognition.lang = 'es-BO'; // Ajustado para Bolivia

      this.recognition.onresult = (event: any) => {
        const texto = event.results[0][0].transcript;
        this.resultado$.next(texto);
      };
    }catch(e){
      console.log(e);
    }
  }

  start() { this.recognition.start(); }
  stop() { this.recognition.stop(); }
}
